import * as React from "react";

import "./two-option-modal.scss";

export const TwoOptionModal = ({messageLine1, messageLine2=null, messageLine3=null, button1Label="Cancel", button2Label="OK", button1Action, button2Action = null}) => (
    <div className="two-option-modal-5th">
        <div className="content">
            <div className="message">
                    {messageLine1}
                
                {messageLine2 && 
                    <div className="sub-text" xd-qa-type="label" xd-qa-name="Confirm Question">
                    {messageLine2}
                    </div>
                }
                {messageLine3 && 
                    <div className="sub-text" xd-qa-type="label" xd-qa-name="Confirm Question">
                        {messageLine3}
                    </div>
                }
            </div>
        </div>
        <div className="footer">
            <button className="cancel" 
                onClick={button1Action} 
                xd-qa-type="button" 
                xd-qa-name={button1Label}
            >
                {button1Label}
            </button>

            {button2Action && <button 
                className="proceed" 
                onClick={button2Action} 
                xd-qa-type="button" 
                xd-qa-name={button2Label}
            >
                {button2Label}
            </button>}
        </div>
    </div>
);